import { useState } from 'react'

export default function WechatManagement() {
  const [accounts] = useState([
    { id: 1, name: '博小兔官方服务号', type: '服务', followers: 12500, status: 'connected' },
    { id: 2, name: '博小兔小程序', type: '小程connected' },
  ])

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📱 微信管理</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>管理微信公众号和小程序绑?</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginBottom: 24 }}>
        {accounts.map(a => (
          <div key={a.id} style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
              <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, background: '#fff', color: '#fff' }}>{a.type}</span>
              <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#fff', color: '#52c41a' }}>已连?</span>
            </div>
            <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8 }}>{a.name}</div>
            <div style={{ fontSize: 13, color: '#666' }}>粉丝? <span style={{ color: '#1890ff', fontWeight: 500 }}>{a.followers.toLocaleString()}</span></div>
          </div>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 8, padding: 20 }}>
        <h3 style={{ fontSize: 14, marginBottom: 16 }}>功能配置</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
          {[
            { name: '模板消息', desc: '活动通知、领取码通知' },
            { name: '客服消息', desc: '自动回复、客服接待' },
            { name: '微信支付', desc: '支付配置' },
            { name: '用户授权', desc: '静默授权、手机号获取' },
          ].map((item, i) => (
            <div key={i} style={{ padding: 16, background: '#fafafa', borderRadius: 8 }}>
              <div style={{ fontWeight: 500, marginBottom: 4 }}>{item.name}</div>
              <div style={{ fontSize: 12, color: '#999' }}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
